import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import CollectionPhotos from '../../components/CollectionPhotos'
import { filterPhotos, assignIndex } from '../../utils'
import { removePhoto, selectPhoto, uploadImages } from '../../actions/photos'
import { selectPhoto as select } from '../../actions/project'

const mapStateToProps = (state, ownState) => ({
  photos: dotProp
    .get(state, 'photos.images', [])
    .map(assignIndex)
    .filter(filterPhotos(dotProp.get(state, 'photos.currentFilter', 'all'))),
  isLoading: dotProp.get(state, 'photos.isLoading', false),
  errMessage: dotProp.get(state, 'photos.errMessage', ''),
  selectedIndex: dotProp.get(state, 'photos.selectedIndex', false),
  photoIsSelected: dotProp.get(state, 'project.selectedIndex', -1) >= 0,
})

const mapDispatchToProps = dispatch => ({
  onClick: index => dispatch(selectPhoto(index)),
  onDrop: (a, r) => dispatch(uploadImages(a, r)),
  action: {
    select: index => dispatch(select(index)),
    remove: index => dispatch(removePhoto(index)),
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionPhotos)



// WEBPACK FOOTER //
// ./src/containers/CollectionPhotos/index.js